module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-LightItalic.807262e.woff2";